module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_fb_01-4312221f40e5816eb4e4194ce86fdde6.png";